import { ApiService } from '../services/index';
import { accessTokenStorage } from '../storage/access-token-storage.util';
import { decodeJWT } from './decode-jwt.util';

const REFRESH_IF_EXPIRES_WITHIN_MS = 120_000;

export const ensureFreshAccessTokenForWs = async (): Promise<void> => {
  const token = accessTokenStorage.get() || '';
  if (!token) return;
  const payload = decodeJWT(token);
  const expMs = typeof payload?.exp === 'number' ? payload.exp * 1000 : null;
  if (expMs !== null && expMs > Date.now() + REFRESH_IF_EXPIRES_WITHIN_MS) return;
  try {
    await ApiService.refreshTokens();
  } catch {
    // Proceed with current token state; handshake may fail.
  }
};
